<template>
    <transition name="fade">
      <div v-if="showGacha" class="modal-container" :style="{ backgroundColor: backgroundColor }">
        <gacha-lottery-modal-animation @start="startAnimation" />
        <transition name="fade">
          <div v-if="showResult && result" class="result" :class="result.type">
            <img :src="resultImage" alt=''>
            <p><span v-html="resultMessage" /></p>
            <div class="button-container">
              <button @click="action">{{ actionButtonLabel }}</button>
            </div>
          </div>
        </transition>
      </div>
      <div v-else-if="showNotice" class="modal-container" :style="{ backgroundColor: backgroundColor }">
        <div class="result notice">
          <img src="~@/assets/img/gacha/multiple-tickets.svg" alt="" />
          <p>
            複数枚のガチャ券を<br />
            獲得した場合は<br />
            「ガチャ取引所」から<br />
            ガチャを引いてください<br />
          </p>
          <div class="button-container">
            <button @click="goToGachaList">「ガチャ取引所」へ</button>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
import { mapActions } from 'vuex'
import DateFormatter from '@/utils/DateFormatter'
import GachaLotteryModalAnimation from '@/views/Gacha/LotteryModalAnimation.vue'
import { GACHA_PRIZE_TYPE, GACHA_RESULT_TYPE } from '@/store/gacha'
import ResultImageHitStamp from '@/assets/img/gacha/result-hit-stamp.svg'
import ResultImageHitCoupon from '@/assets/img/gacha/result-hit-coupon.svg'
import ResultImageFailure from '@/assets/img/gacha/result-failure.svg'

const sleep = (millis) => new Promise(resolve => setTimeout(resolve, millis))

export default {
  name: 'GachaLotteryModal',
  components: { GachaLotteryModalAnimation },
  props: {
    needsBackgroundColor: { type: Boolean, required: true }
  },
  data() {
    return {
      apiType: '4',
      showGacha: false,
      showNotice: false,
      result: null,
      showResult: false
    }
  },
  computed: {
    resultMessage() {
      let message = 'また挑戦してくださいね！'
      if (this.result.type === GACHA_RESULT_TYPE.hit) {
        message = this.result.data.msg.replace(/\n/g, '<br />')
      }
      return message
    },
    actionButtonLabel() {
      let label = '閉じる'
      if (this.result.type === GACHA_RESULT_TYPE.hit) {
        if (
          this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.coupon ||
          this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.prize
        ) {
          label = 'クーポンを見る'
        } else if (this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.stamp) {
          label = 'スタンプを見る'
        }
      }
      return label
    },
    backgroundColor() {
      return this.needsBackgroundColor ? 'rgba(0, 0, 0, 0.85)' : 'none'
    },
    resultImage() {
      let image = null
      if (this.result.type === GACHA_RESULT_TYPE.hit) {
        image = this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.coupon ||
        this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.prize ? ResultImageHitCoupon : ResultImageHitStamp
      } else if (this.result.type === GACHA_RESULT_TYPE.failure) {
        image = ResultImageFailure
      }
      return image
    }
  },
  methods: {
    ...mapActions('Gacha', ['turnGacha', 'setError']),
    ...mapActions('Native', ['actionRequestToken', 'actionRequestExternalLink']),
    async tryGacha(historyId) {
      this.showGacha = true

      const accTime = new DateFormatter().format(new Date())

      const turn = async ({ token, accTime, userId, historyId }) => {
        this.result = await this.turnGacha({ token, accTime, userId, historyId })
        if (this.result.type === GACHA_RESULT_TYPE.error) {
          this.showGacha = false
        }
        this.$emit('finish-gacha')
      }

      window.receivedToken = async (payload) => {
        const json = JSON.parse(payload)
        await turn({ token: json.app_token, accTime, userId: json.user_id, historyId })
      }
      this.actionRequestToken({ apiType: this.apiType, acc_time: accTime, history_id: historyId.toString() })
      // FIXME: for development
      // await turn({ token: 'a', accTime, userId: '89a1636f6b85c0d7', historyId })
    },
    showMultipleTicketsNotice() {
      this.showNotice = true
    },
    action() {
      if (this.result.type === GACHA_RESULT_TYPE.hit) {
        if (
          this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.coupon ||
          this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.prize
        ) {
          this.actionRequestExternalLink('frbbscreen://coupon')
        } else if (this.result.data.gacha_prize.prize_type === GACHA_PRIZE_TYPE.stamp) {
          this.actionRequestExternalLink('frbbscreen://stamp')
        }
      }
      this.$emit('close-lottery-modal')
    },
    async startAnimation() {
      await sleep(1800)
      this.showResult = true
    },
    goToGachaList() {
      this.actionRequestExternalLink('frbbscreen://gachalist')
      this.$emit('close-lottery-modal')
    },
    close() {
      this.showGacha = false
      this.showNotice = false
      this.showResult = false
      this.result = null
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes bounce {
  0% {
    transform: scale(0.3, 0.3);
  }
  100%,
  20%,
  50%,
  80% {
    transform: scale(1, 1);
  }
  40% {
    transform: scale(0.9, 0.9);
  }
  60% {
    transform: scale(0.98, 0.98);
  }
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 2;

  .result {
    width: 80%;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333333;
    z-index: 2;

    &.hit, &.failure {
      animation: bounce 0.8s ease normal 0s none running;
    }

    img {
      padding: 26px 26px 10px;
    }

    p {
      padding: 0 16px 13px;
      text-align: center;
    }

    .button-container {
      width: 100%;
    }

    &.failure {
      p {
        padding: 18px 13px 32px;
      }

      .button-container {
        button {
          width: 100%;
          height: 49px;
          padding: 0 16px;
          border-top: 1px solid #cccccc;
          color: #66160E;
          font-size: 16px;
        }
      }
    }

    &.hit {
      .button-container {
        padding: 0 20px 20px;

        button {
          border-radius: 6px;
          width: 100%;
          background-color: #66160E;
          height: 34px;
          color: #ffffff;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    &.notice {
      img {
        padding: 42px 26px 36px;
      }

      p {
        color: #5a2200;
        padding-bottom: 40px;
      }

      .button-container {
        padding: 0 20px 20px;

        button {
          border-radius: 6px;
          width: 100%;
          background-color: #66160E;
          height: 34px;
          color: #ffffff;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
